<template>
  <div class="canvas-scroll">
    <v-container
      fluid
      class="view-select"
      v-if="tabCount > 1 && tabStyle == 'tab'"
    >
      <v-layout row>
        <v-flex xs6>
          <v-tooltip bottom v-for="(tab, index) in tabArray" :key="index">
            <v-btn
              :color="selection == tab ? 'blue' : 'blue lighten-2'"
              :id="tab"
              slot="activator"
              @click="side(tab)"
            >
              {{ tab }}</v-btn
            >
            <span>{{ $t("Change View to") }} {{ tab }}</span>
          </v-tooltip>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs6 class="row-width">
          <div class="live-container">
            <div class="live-data">{{ $t("LIVE") }}</div>
            <v-progress-linear
              :indeterminate="true"
              height="2"
              :color="'primaryText'"
            ></v-progress-linear>
          </div>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs3 v-if="getSelectedPlantId == 103">
          <v-tooltip bottom class="rightside">
            <v-btn color="primary" slot="activator" @click="show()">{{
              $t("IN/OUT TAG")
            }}</v-btn>
            <span>{{ $t("HELP") }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout row wrap v-if="tabCount > 1 && tabStyle == 'drop down'">
      <v-flex xs12 sm12 md6 lg3 class="selectRoomDropdown">
        <div>
          <v-select
            v-model="selection"
            :items="tabArray"
            label="Select Side"
            outline
          ></v-select>
        </div>
      </v-flex>
    </v-layout>
    <v-container
      fluid
      grid-list-md
      pa-0
      class="live-bg"
      v-else-if="tabCount == 1 && tabStyle == 'none'"
    >
      <v-layout row wrap>
        <v-spacer></v-spacer>
        <v-flex xs1 class="row-width">
          <div class="live-container">
            <div class="live-data">{{ $t("LIVE") }}</div>
            <v-progress-linear
              :indeterminate="true"
              height="2"
            ></v-progress-linear>
          </div>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
    </v-container>
    <v-layout id="tdHover" column>
      <div id="ioTable"></div>
    </v-layout>
    <div id="drawCanvas"></div>
    <div class="legend">
      <div class="normal">
        <span :class="iconClass.success"></span> {{ $t("Closed / On") }}
      </div>
      <div class="fault">
        <span :class="iconClass.failure"></span> {{ $t("Open / Off / Trip") }}
      </div>
      <div class="acknowledge">
        <span class="circle-grey"></span> {{ $t("No Data") }}
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGettersMixin } from "@/util/mixin/index";
import { mapGetters, mapMutations } from "vuex";
import { WriteTableRow, WriteAnnTableRow } from "@/components/sld/js/DrawTable";
import sldAttr from "@/components/sld/json/attributes";
import SldData from "@/services/SLD";
const moment = require("moment");

export default {
  mixins: [mapGettersMixin],
  data() {
    return {
      customCallBack: null,
      paper: null,
      colorCode: {
        null: "#9E9E9E",
        "No Data": "#9E9E9E",
        0: "#3CB371",
        1: "#FF5252",
      },
      tabCount: null,
      tabStyle: "none",
      selection: "",
      imageMap: {},
      sldSym: {},
      legend: false,
      updatedTable: {},
      svgImage: {},
    };
  },
  computed: {
    ...mapGetters(["getSelectedPlantId", "getActivePlantInfo"]),
    computedSvgImage() {
      if (this.isDark) {
        return this.svgImage
      } else {
        let tempSvgImageObj = {}
        Object.keys(this.svgImage).forEach(key => {
          tempSvgImageObj[key] = this.svgImage[key].replace("sld_v1.1/", 'sld_v1.1_light/')
        })
        return tempSvgImageObj
      }
    },
    deviceIconMap() {
      if (_.isEmpty(this.computedSvgImage)) {
        return {};
      } else {
        return {
          inverter: this.computedSvgImage["invImageOff"],
          invImageOn: this.computedSvgImage["invImageOff"],
          invImageOn1: this.computedSvgImage["invImageOff1"],
        };
      }
    },
    tabSelection() {
      return this.sldSym[this.selection];
    },
    tabArray() {
      return this.sldSym.tabs;
    },
    iconColor() {
      if (
        this.sldSym.iconStatusColor &&
        this.sldSym.iconStatusColor.failure === "green"
      ) {
        return {
          success: "red",
          failure: "green",
        };
      } else {
        return {
          success: "green",
          failure: "red",
        };
      }
    },
    iconClass() {
      return {
        success:
          this.iconColor.success == "green" ? "circle-green" : "circle-red",
        failure:
          this.iconColor.failure == "green" ? "circle-green" : "circle-red",
      };
    },
  },
  async mounted() {
    try {
      this.SET_PROGRESS_BAR(true);
      this.svgImage = await SldData.getSVGimage("sld");
      this.sldSym = await SldData.getSymbol(this.getSelectedPlantId);
      this.SET_PROGRESS_BAR(false);
      this.selection = this.sldSym.tabs[0];
      if (this.sldSym.style !== undefined) {
        this.tabStyle = this.sldSym.style;
      }
      this.tabCount = this.sldSym.tabs.length;
      this.legend = this.sldSym[this.selection].legend;
    } catch (err) {
      this.SET_PROGRESS_BAR(false);
    }
    this.drawSld();
  },
  destroyed() {
    if (this.paper) {
      this.paper.remove();
    }
  },
  methods: {
    ...mapMutations(["SET_LAST_CALL_TIME", "SET_PROGRESS_BAR"]),
    callAllApi() {
      let updateTime = moment().format("MM-DD-YYYY H:mm:ss");
      this.SET_LAST_CALL_TIME(updateTime);

      const devicesData = [
        ...new Set([
          ...this.tabSelection.image
            .filter((el) => el.device && el.device != "")
            .map((el) => el.device),
          ...this.tabSelection.devices,
        ]),
      ];
      devicesData.forEach((D) => {
        this.loadData(D);
      });
    },
    show() {
      if (this.getActivePlantInfo("sld_tags_link").includes(".xlsx")) {
        window.open(
          `https://view.officeapps.live.com/op/view.aspx?src=${this.getActivePlantInfo(
            "sld_tags_link"
          )}`,
          "my_window",
          "width=600, height=500, top=100, left=400 "
        );
      } else if (this.getActivePlantInfo("sld_tags_link").includes(".pdf")) {
        window.open(this.getActivePlantInfo("sld_tags_link"));
      }
    },
    side(value) {
      this.selection = value;
    },
    loadData: async function (device) {
      const table = this.tabSelection.table[device];

      // TODO: Later add some key see if the image for
      // the device chages when the data change
      // For now checking if the device is Inv/Breaker/Annunciator
      let imageList = [];
      if (device == "inverter" || device == "breaker") {
        imageList = this.tabSelection.image.filter(
          (obj) => obj.device && obj.device == device
        );
      }

      const tHeight = 20;
      const param = Buffer.from(
        JSON.stringify(
          this.getActivePlantInfo(
            ["rule", "comp_config", "sld", "options", "table", device],
            this.getSelectedPlantId
          )
        )
      ).toString("base64");

      const message = await SldData.getDataV2(
        this.getSelectedPlantId,
        device,
        param
      );

      let tableArr = table;
      if (!Array.isArray(table)) {
        tableArr = [table];
      }
      tableArr.forEach((tableConfig) => {
        const header = tableConfig.header ? tableConfig.header : [];
        const paramMap = tableConfig.paramMap ? tableConfig.paramMap : {};
        const dataHeaderKey =
          tableConfig.data && Object.keys(tableConfig.data).length > 0
            ? Object.keys(tableConfig.data)[0]
            : "";
        const headerName = tableConfig.name ? tableConfig.name : "";

        let headerExist = !(
          headerName === "" &&
          dataHeaderKey &&
          tableConfig.data[`${dataHeaderKey}`].name === ""
        );

        header.forEach((headerItems) => {
          let { x, y, width: cWidth } = headerItems;
          if (headerExist) {
            WriteTableRow(
              "#FF7247",
              x,
              y,
              cWidth,
              tHeight,
              this.paper,
              headerName,
              this.isDark
            );
          }

          Object.keys(paramMap).forEach((key, index) => {
            y = y + tHeight;
            WriteTableRow(
              this.isDark ? "#FFFFFF" : "#04112F",
              x,
              y,
              cWidth,
              tHeight,
              this.paper,
              paramMap[key],
              this.isDark
            );
          });
        });

        let dataLayout = tableConfig.direction;
        let tableData = tableConfig.data ? tableConfig.data : {};
        let itemsThreshold = tableConfig.threshold ? tableConfig.threshold : {};

        // Table Data
        imageList
          .filter((el) => el.uId != "")
          .forEach((el) => {
            let idKey = el.uId;
            const jusVal = message[idKey];

            const index = imageList.findIndex((obj) => obj.uId == idKey);
            if (index >= 0) {
              if (device === "inverter") {
                let invIconSuccess = this.svgImage[el.id],
                  invIconFailure = this.deviceIconMap[el.id];
                if (this.iconColor.success == "red") {
                  invIconSuccess = this.deviceIconMap[el.id];
                  invIconFailure = this.svgImage[el.id];
                }
                if (
                  jusVal === undefined &&
                  this.imageMap[device][idKey].obj !== undefined
                ) {
                  this.imageMap[device][idKey].obj.attr({
                    src: invIconFailure,
                  });
                } else if (
                  jusVal !== undefined &&
                  this.imageMap[device][idKey].obj !== undefined
                ) {
                  if (jusVal && jusVal["Inverter Alert"] === 1) {
                    this.imageMap[device][idKey].obj.attr({
                      src: invIconFailure,
                    });
                  } else {
                    this.imageMap[device][idKey].obj.attr({
                      src: invIconSuccess,
                    });
                  }
                } else {
                  this.imageMap[device][idKey].obj.attr({
                    src: invIconSuccess,
                  });
                }
              }

              if (device === "breaker") {
                let val = null;
                if (jusVal == undefined || jusVal == null) {
                  val = -1;
                } else if (jusVal["ON"] === 1 && jusVal["OFF"] === 0) {
                  val = 1;
                } else if (
                  jusVal["ON"] === 0 &&
                  (jusVal["OFF"] === 1 || jusVal["TRIP"] === 1)
                ) {
                  val = 0;
                }

                if (imageList[index].id == "vcb") {
                  let vcbIconSuccess =
                      "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/vcb/sld_vcb_green_ta1_ba1.svg",
                    vcbIconFailure =
                      "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/vcb/sld_vcb_red_ta1_ba1.svg";
                  if (this.iconColor.success == "red") {
                    vcbIconSuccess =
                      "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/vcb/sld_vcb_red_ta1_ba1.svg";
                    vcbIconFailure =
                      "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/vcb/sld_vcb_green_ta1_ba1.svg";
                  }
                  switch (val) {
                    case 0:
                      this.imageMap[device][idKey].obj.attr({
                        src: vcbIconFailure,
                      });
                      break;
                    case 1:
                      this.imageMap[device][idKey].obj.attr({
                        src: vcbIconSuccess,
                      });
                      break;
                    case -1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/vcb/sld_vcb_ta1_ba1_disable.svg",
                      });
                      break;
                  }
                } else if (imageList[index].id === "isolatorVer") {
                  // Isolator without earth
                  switch (val) {
                    case 0:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/isolatorVerRed.svg",
                      });
                      break;
                    case 1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/isolatorVer.svg",
                      });
                      break;
                    case -1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/isolatorVer.svg",
                      });
                      break;
                  }
                } else if (imageList[index].id === "motorizedSwitchVer") {
                  switch (val) {
                    case 0:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/motorizedSwitchRedVer.svg",
                      });
                      break;
                    case 1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/motorizedSwitchVer.svg",
                      });
                      break;
                    case -1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/motorizedSwitchVer.svg",
                      });
                      break;
                  }
                } else if (imageList[index].id === "motorizedSwitchHor") {
                  switch (val) {
                    case 0:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/motorizedSwitchRedHor.svg",
                      });
                      break;
                    case 1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/motorizedSwitchHor.svg",
                      });
                      break;
                    case -1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/motorizedSwitchHor.svg",
                      });
                      break;
                  }
                } else if (imageList[index].id === "earthSwitchVer") {
                  switch (val) {
                    case 0:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/earthSwitchRedVer.svg",
                      });
                      break;
                    case 1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/earthSwitchVer.svg",
                      });
                      break;
                    case -1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/earthSwitchVer.svg",
                      });
                      break;
                  }
                } else if (imageList[index].id === "earthSwitchHor") {
                  switch (val) {
                    case 0:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/earthSwitchRedHor.svg",
                      });
                      break;
                    case 1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/earthSwitchHor.svg",
                      });
                      break;
                    case -1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/earthSwitchHor.svg",
                      });
                      break;
                  }
                } else if (imageList[index].id == "isolator") {
                  // Isolator with earth
                  switch (val) {
                    case 0:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/isolatorRed.svg",
                      });
                      break;
                    case 1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/isolator.svg",
                      });
                      break;
                    case -1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/isolatorDisable.svg",
                      });
                      break;
                  }
                } else if (imageList[index].id == "rectangle") {
                  // Isolator with earth
                  let rectIconSuccess =
                      "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/scb/rectangleGreen.svg",
                    rectIconFailure =
                      "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/scb/rectangleRed.svg";
                  if (this.iconColor.success == "red") {
                    rectIconSuccess =
                      "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/scb/rectangleRed.svg";
                    rectIconFailure =
                      "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/scb/rectangleGreen.svg";
                  }
                  switch (val) {
                    case 0:
                      this.imageMap[device][idKey].obj.attr({
                        src: rectIconFailure,
                      });
                      break;
                    case 1:
                      this.imageMap[device][idKey].obj.attr({
                        src: rectIconSuccess,
                      });
                      break;
                    case -1:
                      this.imageMap[device][idKey].obj.attr({
                        src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/scb/rectangleDisable.svg",
                      });
                      break;
                  }
                }
              }

              if (
                device === "annunciator" ||
                device === "annunciator12" ||
                device === "annunciator34" ||
                device === "annunciatorOG"
              ) {
                let tags = Object.values(paramMap);
                if (message === {} || jusVal === undefined) {
                  this.imageMap[device][idKey].obj.attr({
                    src: this.svgImage["annunciatorGrey"],
                  });
                } else {
                  const deviceData = message[idKey];
                  const computedData = tags.reduce((previous, tag) => {
                    if (deviceData[tag] === null) {
                      previous;
                    } else {
                      previous + deviceData[tag];
                    }
                  }, null);

                  let result = null;
                  let annunciatorIconSuccess = this.svgImage["annunciator"],
                    annunciatorIconFailure = this.svgImage["annunciatorRed"];
                  if (this.iconColor.success == "red") {
                    annunciatorIconSuccess = this.svgImage["annunciatorRed"];
                    annunciatorIconFailure = this.svgImage["annunciator"];
                  }
                  if (computedData === null) {
                    result = this.svgImage["annunciatorGrey"];
                  } else if (computedData > 0) {
                    result = annunciatorIconFailure;
                  } else {
                    result = annunciatorIconSuccess;
                  }
                  this.imageMap[device][idKey].obj.attr({
                    src: result,
                  });
                }
              }

              if (el.deg && el.deg > 0) {
                this.imageMap[device][idKey].obj.rotate(el.deg);
              }
            }
          });

        Object.keys(tableData).forEach((idKey) => {
          const jusVal = message[idKey];

          let { x, y, width: cWidth } = tableData[idKey];
          if (headerExist) {
            WriteTableRow(
              this.isDark ? "#FFFFFF" : "#04112F",
              x,
              y,
              cWidth,
              tHeight,
              this.paper,
              "" + tableData[idKey].name,
              this.isDark
            );
          }

          if (dataLayout === undefined || dataLayout === "default") {
            if (
              device === "relay" ||
              device === "annunciator" ||
              device === "annunciator12" ||
              device === "annunciator34" ||
              device === "annunciatorOG"
            ) {
              if (jusVal === undefined) {
                Object.keys(paramMap).forEach((key) => {
                  y = y + tHeight;
                  WriteAnnTableRow(
                    this.colorCode["No Data"],
                    x,
                    y,
                    cWidth,
                    tHeight,
                    this.paper,
                    "",
                    this.isDark
                  );
                });
              } else {
                let tableIconSuccess = this.colorCode[0],
                  tableIconError = this.colorCode[1];
                if (this.iconColor.success == "red") {
                  tableIconSuccess = this.colorCode[1];
                  tableIconError = this.colorCode[0];
                }
                Object.keys(paramMap).forEach((key) => {
                  let dataValue = "";
                  if (key.toLowerCase() === "unit ready") {
                    dataValue = isNaN(parseFloat(jusVal[key]))
                      ? this.colorCode["No Data"]
                      : parseFloat(jusVal[key]).toFixed(0) > 0
                      ? tableIconSuccess
                      : tableIconError;
                  } else {
                    dataValue = isNaN(parseFloat(jusVal[key]))
                      ? this.colorCode["No Data"]
                      : parseFloat(jusVal[key]).toFixed(0) > 0
                      ? tableIconError
                      : tableIconSuccess;
                  }
                  y = y + tHeight;
                  WriteAnnTableRow(
                    dataValue,
                    x,
                    y,
                    cWidth,
                    tHeight,
                    this.paper,
                    "",
                    this.isDark
                  );
                });
              }
            } else {
              if (jusVal === undefined) {
                Object.keys(paramMap).forEach((key) => {
                  y = y + tHeight;
                  WriteTableRow(
                    "#FF5252",
                    x,
                    y,
                    cWidth,
                    tHeight,
                    this.paper,
                    "No Data",
                    this.isDark
                  );
                });
              } else {
                Object.keys(paramMap).forEach((key) => {
                  // Check if value is a number
                  let dataValue = isNaN(parseFloat(jusVal[key]))
                    ? "No Data"
                    : device === "annunciatorOG" ||
                      device === "annunciator12" ||
                      device === "annunciator34"
                    ? parseFloat(jusVal[key]).toFixed(0)
                    : parseFloat(jusVal[key]).toFixed(1);
                  y = y + tHeight;
                  let color = (
                    dataValue !== "No Data"
                      ? dataValue > itemsThreshold[key]
                      : false
                  )
                    ? "#668cf6" // 000427
                    : "#FF5252";
                  WriteTableRow(
                    color,
                    x,
                    y,
                    cWidth,
                    tHeight,
                    this.paper,
                    dataValue,
                    this.isDark
                  );
                });
              }
            }
          } else {
            if (jusVal === undefined) {
              Object.keys(paramMap).forEach((key) => {
                WriteTableRow(
                  "#FF5252",
                  x + cWidth,
                  y,
                  cWidth,
                  tHeight,
                  this.paper,
                  "No Data",
                  this.isDark
                );
              });
            } else {
              Object.keys(paramMap).forEach((key) => {
                // Check if value is a number
                let dataValue = isNaN(parseFloat(jusVal[key]))
                  ? "No Data"
                  : parseFloat(jusVal[key]).toFixed(1);
                y = y + tHeight;
                let color = (
                  dataValue !== "No Data"
                    ? dataValue > itemsThreshold[key]
                    : false
                )
                  ? "#668cf6"
                  : "#FF5252";
                WriteTableRow(
                  color,
                  x + cWidth,
                  y,
                  cWidth,
                  tHeight,
                  this.paper,
                  dataValue,
                  this.isDark
                );
              });
            }
          }
        });
      });
    },
    updateTableData() {
      let device = Object.keys(this.updatedTable)[0];
      const table = this.tabSelection.table[device];

      if (!table) return;
      let imageList = [];
      if (device == "inverter" || device == "breaker") {
        imageList = this.tabSelection.image.filter(
          (obj) => obj.device && obj.device == device
        );
      }
      const tHeight = 20;

      let tableArr = table;
      if (!Array.isArray(table)) {
        tableArr = [table];
      }
      tableArr.forEach((tableConfig) => {
        const paramMap = tableConfig.paramMap ? tableConfig.paramMap : {};

        let dataLayout = tableConfig.direction;
        let tableData = tableConfig.data ? tableConfig.data : {};
        let itemsThreshold = tableConfig.threshold ? tableConfig.threshold : {};

        // Table Data
        let idKey = Object.keys(this.updatedTable[device]);

        if (idKey.length == 0) return;
        let jusVal = this.updatedTable[device][idKey];
        const index = imageList.findIndex((obj) => obj.uId == idKey);

        if (index >= 0) {
          if (device === "inverter" && idKey.length > 0) {
            let invIconSuccess = this.svgImage[this.imageMap[device][idKey].id],
              invIconFailure =
                this.deviceIconMap[this.imageMap[device][idKey].id];
            if (this.iconColor.success == "red") {
              invIconSuccess =
                this.deviceIconMap[this.imageMap[device][idKey].id];
              invIconFailure = this.svgImage[this.imageMap[device][idKey].id];
            }
            if (
              jusVal === undefined &&
              this.imageMap[device][idKey].obj !== undefined
            ) {
              this.imageMap[device][idKey]["obj"].attr({
                src: invIconFailure,
              });
            } else if (
              jusVal !== undefined &&
              this.imageMap[device][idKey].obj !== undefined
            ) {
              if (jusVal && jusVal["ac_power"] <= 0) {
                this.imageMap[device][idKey]["obj"].attr({
                  src: invIconFailure,
                });
              } else {
                this.imageMap[device][idKey].obj.attr({
                  src: invIconSuccess,
                });
              }
            } else {
              this.imageMap[device][idKey].obj.attr({
                src: invIconSuccess,
              });
            }
          }

          if (device === "breaker") {
            let val = null;
            if (jusVal == undefined || jusVal == null) {
              val = -1;
            } else if (
              jusVal["breaker_on"] === 1 &&
              jusVal["breaker_off"] === 0
            ) {
              val = 1;
            } else if (
              jusVal["breaker_on"] === 0 &&
              (jusVal["breaker_off"] === 1 || jusVal["breaker_trip"] === 1)
            ) {
              val = 0;
            }

            if (imageList[index].id === "vcb") {
              let vcbIconSuccess =
                  "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/vcb/sld_vcb_green_ta1_ba1.svg",
                vcbIconFailure =
                  "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/vcb/sld_vcb_red_ta1_ba1.svg";
              if (this.iconColor.success == "red") {
                vcbIconSuccess =
                  "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/vcb/sld_vcb_red_ta1_ba1.svg";
                vcbIconFailure =
                  "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/vcb/sld_vcb_green_ta1_ba1.svg";
              }
              switch (val) {
                case 0:
                  this.imageMap[device][idKey].obj.attr({
                    src: vcbIconFailure,
                  });
                  break;
                case 1:
                  this.imageMap[device][idKey].obj.attr({
                    src: vcbIconSuccess,
                  });
                  break;
                case -1:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/vcb/sld_vcb_ta1_ba1_disable.svg",
                  });
                  break;
              }
            } else if (imageList[index].id === "isolatorVer") {
              // Isolator without earth
              switch (val) {
                case 0:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/isolatorVerRed.svg",
                  });
                  break;
                case 1:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/isolatorVer.svg",
                  });
                  break;
                case -1:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/isolatorVer.svg",
                  });
                  break;
              }
            } else if (imageList[index].id === "motorizedSwitchVer") {
              switch (val) {
                case 0:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/motorizedSwitchRedVer.svg",
                  });
                  break;
                case 1:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/motorizedSwitchVer.svg",
                  });
                  break;
                case -1:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/motorizedSwitchVer.svg",
                  });
                  break;
              }
            } else if (imageList[index].id === "motorizedSwitchHor") {
              switch (val) {
                case 0:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/motorizedSwitchRedHor.svg",
                  });
                  break;
                case 1:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/motorizedSwitchHor.svg",
                  });
                  break;
                case -1:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/motorizedSwitchHor.svg",
                  });
                  break;
              }
            } else if (imageList[index].id === "earthSwitchVer") {
              switch (val) {
                case 0:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/earthSwitchRedVer.svg",
                  });
                  break;
                case 1:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/earthSwitchVer.svg",
                  });
                  break;
                case -1:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/earthSwitchVer.svg",
                  });
                  break;
              }
            } else if (imageList[index].id == "isolator") {
              // Isolator with earth
              switch (val) {
                case 0:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/isolatorRed.svg",
                  });
                  break;
                case 1:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/isolator.svg",
                  });
                  break;
                case -1:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/isolator/isolator.svg",
                  });
                  break;
              }
            } else if (imageList[index].id == "rectangle") {
              // Isolator with earth
              let rectIconSuccess =
                  "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/scb/rectangleGreen.svg",
                rectIconFailure =
                  "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/scb/rectangleRed.svg";
              if (this.iconColor.success == "red") {
                rectIconSuccess =
                  "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/scb/rectangleRed.svg";
                rectIconFailure =
                  "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/scb/rectangleGreen.svg";
              }
              switch (val) {
                case 0:
                  this.imageMap[device][idKey].obj.attr({
                    src: rectIconFailure,
                  });
                  break;
                case 1:
                  this.imageMap[device][idKey].obj.attr({
                    src: rectIconSuccess,
                  });
                  break;
                case -1:
                  this.imageMap[device][idKey].obj.attr({
                    src: "https://scada4x-assets.s3.ap-south-1.amazonaws.com/sld_v1.1/scb/rectangleDisable.svg",
                  });
                  break;
              }
            }
          }

          if (
            device === "annunciator" ||
            device === "annunciator12" ||
            device === "annunciator34" ||
            device === "annunciatorOG"
          ) {
            let tags = Object.values(paramMap);
            if (this.updatedTable[device] === {} || jusVal === undefined) {
              return this.imageMap[device][idKey].obj.attr({
                src: this.svgImage["annunciatorGrey"],
              });
            } else {
              const deviceData = this.updatedTable[device][idKey];
              const computedData = tags.reduce((previous, tag) => {
                if (deviceData[tag] === null) {
                  return previous;
                } else if (previous === null) {
                  return deviceData[tag];
                } else {
                  return previous + deviceData[tag];
                }
              }, null);

              let result = null;
              let annunciatorIconSuccess = this.svgImage["annunciator"],
                annunciatorIconFailure = this.svgImage["annunciatorRed"];
              if (this.iconColor.success == "red") {
                annunciatorIconSuccess = this.svgImage["annunciatorRed"];
                annunciatorIconFailure = this.svgImage["annunciator"];
              }
              if (computedData === null) {
                result = this.svgImage["annunciatorGrey"];
              } else if (computedData > 0) {
                result = annunciatorIconFailure;
              } else {
                result = annunciatorIconSuccess;
              }
              this.imageMap[device][idKey].obj.attr({
                src: result,
              });

              if (imageList[index].deg && imageList[index].deg > 0) {
                this.imageMap[device][idKey].obj.rotate(imageList[index].deg);
              }
            }
          }
        }

        // y = y + tHeight
        let newVal = {};
        let paramTable = Object.entries(
          this.getActivePlantInfo(
            ["rule", "comp_config", "sld", "options", "table", device],
            this.getSelectedPlantId
          )
        );
        if (device === "inverter") {
          paramTable.push(["Generation (kWh)", "Generation (kWh)"]);
        }
        if (device === "energy meter") {
          paramTable.push(
            ["Daily Export (kWh)", "Daily Export (kWh)"],
            ["Daily Import (kWh)", "Daily Import (kWh)"]
          );
        }
        paramTable.forEach((p) => {
          if (device === "zmu") {
            newVal[p[1]] = jusVal[p[1]];
          } else {
            newVal[p[1]] = jusVal[p[0]];
          }
        });
        // Draw Table
        if (!Object.keys(tableData).length) {
          return;
        }
        let { x, y, width: cWidth } = tableData[idKey];
        if (dataLayout === undefined || dataLayout === "default") {
          if (
            device === "relay" ||
            device === "annunciator" ||
            device === "annunciator12" ||
            device === "annunciator34" ||
            device === "annunciatorOG"
          ) {
            if (newVal === undefined) {
              Object.keys(paramMap).forEach((key) => {
                y = y + tHeight;
                WriteAnnTableRow(
                  this.colorCode["No Data"],
                  x,
                  y,
                  cWidth,
                  tHeight,
                  this.paper,
                  ""
                );
              });
            } else {
              let tableIconSuccess = this.colorCode[0],
                tableIconError = this.colorCode[1];
              if (this.iconColor.success == "red") {
                tableIconSuccess = this.colorCode[1];
                tableIconError = this.colorCode[0];
              }
              Object.keys(paramMap).forEach((key) => {
                let dataValue = "";
                if (key.toLowerCase() === "unit ready") {
                  dataValue = isNaN(parseFloat(newVal[key]))
                    ? this.colorCode["No Data"]
                    : parseFloat(newVal[key]).toFixed(0) > 0
                    ? tableIconSuccess
                    : tableIconError;
                } else {
                  dataValue = isNaN(parseFloat(newVal[key]))
                    ? this.colorCode["No Data"]
                    : parseFloat(newVal[key]).toFixed(0) > 0
                    ? tableIconError
                    : tableIconSuccess;
                }
                y = y + tHeight;
                WriteAnnTableRow(
                  dataValue,
                  x,
                  y,
                  cWidth,
                  tHeight,
                  this.paper,
                  ""
                );
              });
            }
          } else {
            if (newVal === undefined) {
              Object.keys(paramMap).forEach((key) => {
                y = y + tHeight;
                WriteTableRow(
                  "#FF5252",
                  x,
                  y,
                  cWidth,
                  tHeight,
                  this.paper,
                  "No Data",
                  this.isDark
                );
              });
            } else {
              Object.keys(paramMap).forEach((key) => {
                // Check if value is a number
                let dataValue = isNaN(parseFloat(newVal[key]))
                  ? "No Data"
                  : device === "annunciatorOG" ||
                    device === "annunciator12" ||
                    device === "annunciator34"
                  ? parseFloat(newVal[key]).toFixed(0)
                  : parseFloat(newVal[key]).toFixed(1);
                y = y + tHeight;
                let color = (
                  dataValue !== "No Data"
                    ? dataValue > itemsThreshold[key]
                    : false
                )
                  ? "#668cf6"
                  : "#FF5252";
                WriteTableRow(
                  color,
                  x,
                  y,
                  cWidth,
                  tHeight,
                  this.paper,
                  dataValue,
                  this.isDark
                );
              });
            }
          }
        } else {
          if (newVal === undefined) {
            Object.keys(paramMap).forEach((key) => {
              WriteTableRow(
                "#FF5252",
                x + cWidth,
                y,
                cWidth,
                tHeight,
                this.paper,
                "No Data",
                this.isDark
              );
            });
          } else {
            Object.keys(paramMap).forEach((key) => {
              // Check if value is a number
              let dataValue = isNaN(parseFloat(newVal[key]))
                ? "No Data"
                : parseFloat(newVal[key]).toFixed(1);
              y = y + tHeight;
              let color = (
                dataValue !== "No Data"
                  ? dataValue > itemsThreshold[key]
                  : false
              )
                ? "#668cf6"
                : "#FF5252";
              WriteTableRow(
                color,
                x + cWidth,
                y,
                cWidth,
                tHeight,
                this.paper,
                dataValue,
                this.isDark
              );
            });
          }
        }
      });
    },
    setToFixed(value, valueID, precession = 2) {
      if (value === null || value === undefined) {
        return value;
      } else if (valueID === undefined) {
        return value;
      } else {
        if (typeof value[valueID] === "number") {
          return parseFloat(value[valueID]).toFixed(precession);
        } else {
          return value[valueID];
        }
      }
    },
    tablePosition: (event) => {
      return event.clientX > screen.width - 550;
    },
    displayTable: async function (device, uId, hoverConfig, tableIsLeft) {
      const tableResponse = await SldData.geHoverDataV2(
        this.getSelectedPlantId,
        device,
        uId
      );
      this.updatedTable = {
        [device]: tableResponse,
      };

      let { input: symInput, output: symOutput } = hoverConfig;

      let tableDateContainer = document.getElementById("tdHover");
      if (tableIsLeft) {
        tableDateContainer.classList.remove("rightData");
        tableDateContainer.classList.add("leftData");
      } else {
        tableDateContainer.classList.remove("leftData");
        tableDateContainer.classList.add("rightData");
      }
      const tableDate = document.getElementById("ioTable");
      let tableMessage = tableResponse;
      if (uId !== undefined) {
        let inputKeys = Object.keys(symInput);
        let totalInputKey = inputKeys.length;
        let outputKeys = Object.keys(symOutput);
        let totalOutputKey = outputKeys.length;

        const emValue = Object.values(tableMessage)[0];
        let tempTable = ``;
        tempTable = `
              <table id="hoverTable">
                <tr id="tableRow">`;
        if (totalInputKey > 0) {
          tempTable += `
                  <th class="col col-in">
                    ${this.$t("Input")}
                  </th>
                  <th class="col col-in">
                    ${this.$t("Value")}
                  </th>`;
        }
        if (totalOutputKey > 0) {
          tempTable += `
                  <th class="col col-out">
                    ${this.$t("Output")}
                  </th>
                  <th class="col col-out">
                    ${this.$t("Value")}
                  </th>`;
        }
        tempTable += `</tr>`;

        let range =
          totalInputKey > totalOutputKey ? totalInputKey : totalOutputKey;
        for (let index = 0; index < range; index++) {
          let outputIndex;
          let inputIndex;
          if (
            device === "annunciator12" ||
            device === "annunciatorOG" ||
            device === "annunciator34"
          ) {
            outputIndex = this.setToFixed(emValue, outputKeys[index], 0);
            inputIndex = this.setToFixed(emValue, inputKeys[index], 0);
          } else {
            outputIndex = this.setToFixed(emValue, outputKeys[index]);
            inputIndex = this.setToFixed(emValue, inputKeys[index]);
          }

          if (totalInputKey > 0) {
            tempTable += '<tr id="tableRow">';
            tempTable += `<td id="tableData" class="col"> ${
              index < totalInputKey ? symInput[inputKeys[index]] : ""
            }</td>`;
            let hovData = this.getHoverData(
              inputIndex,
              index,
              totalInputKey
            )
            if (hovData == 'No Data' || hovData == null) {
              tempTable += `<td id="tableData" class="col-no-data"> ${hovData}</td>`;
            } else {
              tempTable += `<td id="tableData" class="col-value"> ${hovData}</td>`;
            }
          }
          if (totalOutputKey > 0) {
            tempTable += `<td id="tableData" class="col">${
              index < totalOutputKey ? symOutput[outputKeys[index]] : ""
            }</td>`;
            let hovData = this.getHoverData(
              outputIndex,
              index,
              totalOutputKey
            )
            if (hovData == 'No Data' || hovData == null) {
              tempTable += `<td id="tableData" class="col-no-data"> ${hovData}</td>`;
            } else {
              tempTable += `<td id="tableData" class="col-value"> ${hovData}</td>`;
            }

            tempTable += "</tr>";
          }
        }
        tempTable += "</table>";
        tableDate.innerHTML = tempTable;
      }
    },
    hideTable() {
      document.getElementById("tdHover").style.display = "none";
    },
    getHoverData(outputIndex, index, totalInputKey) {
      let result = "";

      if (index < totalInputKey) {
        if (outputIndex == null) {
          result = "No Data";
        } else {
          result = outputIndex;
        }
      }
      return result;
    },
    drawImage() {
      this.tabSelection.image.forEach((symbolItems) => {
        let items = null;
        const { uId, device } = symbolItems;
        if (
          symbolItems.device === "inverter" ||
          symbolItems.device === "breaker" ||
          symbolItems.device === "annunciator" ||
          symbolItems.device === "annunciator12" ||
          symbolItems.device === "annunciator34" ||
          symbolItems.device === "annunciatorOG"
        ) {
          items = this.paper.image(
            this.computedSvgImage[symbolItems.id],
            symbolItems.x,
            symbolItems.y,
            symbolItems.width,
            symbolItems.height
          );
          if (uId !== undefined) {
            if (!this.imageMap[device]) {
              this.imageMap[device] = {};
            }
            this.imageMap[device][uId] = {
              obj: items,
              id: symbolItems.id,
            };
          }
        } else {
          items = this.paper.image(
            this.computedSvgImage[symbolItems.id],
            symbolItems.x,
            symbolItems.y,
            symbolItems.width,
            symbolItems.height
          );
        }
        if (this.tabSelection.hoverProperty[device]) {
          items.node.onmouseenter = () => {
            const isLeft = this.tablePosition(event);
            let tableDateContainer = document.getElementById("tdHover");
            tableDateContainer.style.display = "flex";

            let configHover = {};
            if (!Array.isArray(this.tabSelection.table[device])) {
              configHover = [this.tabSelection.table[device]];
            } else {
              configHover = this.tabSelection.table[device].filter((obj) => {
                const isPresent = Object.keys(obj.data).some((id) => id == uId);
                return (
                  isPresent &&
                  ((obj.config_hover.input &&
                    Object.keys(obj.config_hover.input).length > 0) ||
                    (obj.config_hover.output &&
                      Object.keys(obj.config_hover.output).length > 0))
                );
              });
            }
            if (configHover.length) {
              this.customCallBack = () =>
                this.displayTable(
                  device,
                  uId,
                  this.tabSelection.table[device].config_hover,
                  isLeft
                );
              this.displayTable(
                device,
                uId,
                this.tabSelection.table[device].config_hover,
                isLeft
              );
            }
          };
          items.node.onmouseleave = () => {
            this.customCallBack = null;
            this.hideTable();
          };
        }
        if (symbolItems.location) {
          items.click(() => {
            this.$router.push(symbolItems.location);
          });
        }
      });
    },
    drawReact() {
      let sldRect = this.tabSelection.rect ? this.tabSelection.rect : [];
      sldRect.forEach((items) => {
        let rect = this.paper.rect(items.x, items.y, items.width, items.height);
        if (!this.isDark && sldAttr[`${items.attr}Light`]) {
          rect.attr(sldAttr[`${items.attr}Light`]);
        } else {
          rect.attr(sldAttr[items.attr]);
        }
        rect.node.id = rect.id;
      });
    },
    drawText() {
      let sldText = this.tabSelection.text ? this.tabSelection.text : [];
      sldText.forEach((textItems) => {
        let text = this.paper.text(textItems.x, textItems.y, textItems.name);
        if (!this.isDark && sldAttr[`${textItems.attr}Light`]) {
          text.attr(sldAttr[`${textItems.attr}Light`]);
        } else {
          text.attr(sldAttr[textItems.attr]);
        }
      });
    },
    drawPath() {
      let sldPath = this.tabSelection.path ? this.tabSelection.path : [];
      sldPath.forEach((pathItems) => {
        let path = this.paper.path(pathItems.image);
        if (!this.isDark && sldAttr[`${pathItems.attr}Light`]) {
          path.attr(sldAttr[`${pathItems.attr}Light`]);
        } else {
          path.attr(sldAttr[pathItems.attr]);
        }
        // path.attr(sldAttr[pathItems.attr]);
        path.node.id = pathItems.id;
      });
    },
    drawSld() {
      this.paper = Raphael(
        "drawCanvas",
        this.tabSelection.paper.width,
        this.tabSelection.paper.height
      );
      this.setIntervalWithoutDelay(() => {
        if (typeof this.customCallBack === "function") {
          this.customCallBack();
        }
        this.callAllApi();
      }, 60000);
      this.drawText();
      this.drawReact();
      this.drawPath();
      this.drawImage();
    },
  },
  watch: {
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(() => {
          if (typeof this.customCallBack === "function") {
            this.customCallBack();
          }
          this.callAllApi();
        }, 60000);
      }
    },
    theme() {
      if (this.paper) {
        this.paper.remove();
      }
      this.drawSld();
    },
    selection(newVal, oldVal) {
      if (oldVal != "") {
        if (this.paper) {
          this.paper.remove();
        }
        this.drawSld();
      }
    },
    async getSelectedPlantId() {
      try {
        this.sldSym = await SldData.getSymbol(this.getSelectedPlantId);
        this.selection = this.sldSym.tabs[0];
        if (this.sldSym.style !== undefined) {
          this.tabStyle = this.sldSym.style;
        }
        this.tabCount = this.sldSym.tabs.length;
        this.legend = this.sldSym[this.selection].legend;
        if (this.paper) {
          this.paper.remove();
        }
        this.drawSld();
      } catch (err) {
        if (this.paper) {
          this.paper.remove();
        }
      }
    },
    updatedTable: {
      handler() {
        this.updateTableData();
      },
      deep: true,
    },
  },
};
</script>

<style>
#drawCanvas {
  width: 1500px;
  overflow-x: visible;
  position: relative;
  top: 75px;
  transform: scale(1.1, 1.1);
}

.v-progress-linear {
  margin: 0;
}

.live-data {
  animation: flipAni 4s 0s linear infinite;
}

#hoverTable {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#hoverTable #tableData {
  border: 1px solid #34495e;
  padding: 2px;
}

#hoverTable #tableRow {
  text-align: center;
  background-color: var(--v-primary-base);
  color: var(--v-primaryText-base);
}

.col {
  width: 300px;
  text-align: center;
  padding: 6px;
  border: 1px solid #34495e;
}

.canvas-scroll {
  overflow-x: auto;
  overflow-y: hidden;
}

.live-container {
  width: 50px;
}

div #ioTable {
  width: 500px;
  right: 8px;
  top: 110px;
}

div #tdHover {
  display: none;
  width: 500px;
  position: fixed;
  right: 8px;
  top: 110px;
}

.rightside {
  float: right;
}

.leftside {
  float: left;
}

.rightData {
  display: none;
  width: 300px;
  position: fixed;
  right: 8px;
  top: 110px;
  z-index: 3;
  /* color: var(--v-primaryText-base); */
}

.leftData {
  display: none;
  width: 300px;
  position: fixed;
  left: 8px;
  top: 110px;
  z-index: 3;
  /* color: var(--v-primaryText-base); */
}

.col-value {
  color: #668cf6;
}

.col-no-data {
  color: #FF5252;
}

.legend {
  position: absolute;
  top: 85px;
  right: 35px;
  width: 140px;
  color: var(--v-primaryText-base);
  border: 1px solid var(--v-primaryText-base);
  padding: 10px;
}

.circle-green {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #3cb371;
  border-radius: 50%;
}

.circle-red {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #ff5252;
  border-radius: 50%;
}

.circle-grey {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #9e9e9e;
  border-radius: 50%;
}

@media only screen and (max-width: 576px) {
  #drawCanvas {
    background-color: #1c2137;
    overflow-x: auto;
    position: absolute;
  }
}

@keyframes flipAni {
  0% {
    transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -o-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
  }

  50% {
    transform: scale(-1, 1);
    -webkit-transform: scale(-1, 1);
    -moz-transform: scale(-1, 1);
    -o-transform: scale(-1, 1);
    -ms-transform: scale(-1, 1);
  }

  100% {
    transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -o-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
  }
}
</style>
